class PromoPopup extends HTMLElement {
  constructor() {
    super();

    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', event => {
      if (event.code?.toUpperCase() === 'ESCAPE') this.hide();
    });
    this.addEventListener('click', event => {
      if (event.target === this) this.hide();
    });

    this.promoTriggers = document.querySelectorAll('.js-open-promo-popup');
    const recentlyViewedProducts = document.querySelector('recently-viewed-products'); // The element to observe

    if (recentlyViewedProducts){
      const callback = (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.promoTriggers = document.querySelectorAll('.js-open-promo-popup');
            this.connectedCallback();
            observer.unobserve(recentlyViewedProducts); // Stop observing after the first intersection
          } 
        });
      };
  
      const observer = new IntersectionObserver(callback);
      observer.observe(recentlyViewedProducts);
    }

  }

  connectedCallback() {
    if(this.promoTriggers.length > 0) {
      this.promoTriggers.forEach(button => {
        button.addEventListener('click', (event) => {
          let target = event.currentTarget

          if (!target.querySelector('#promo-popupJSON')) return;

          let popupDataJSON = JSON.parse(target.querySelector('#promo-popupJSON').innerHTML);

          this.openPopup(popupDataJSON);
        });
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    this.setAttribute('open', '');
    document.documentElement.classList.add("lock-all");
  }

  hide() {
    document.documentElement.classList.remove("lock-all");
    this.removeAttribute('open');
  }

  openPopup(popupData){
    let {image, main_title, text, secound_title, button_text, button_url} = popupData;
    let html = `
      <div class="promo-popup__content">
        ${image || main_title ? `
          <div class="promo-popup__content--head">
            ${image ? `<img src="${image}" width="200" height="200" alt="Promo Image" class="promo-popup__head--image">`: ''}
            ${main_title ? `<div class="promo-popup__head--title h5">${main_title}</div>` : ''}
          </div>
        ` : ''}
        ${secound_title && `<div class="promo-popup__content--secound-title h6">${secound_title}</div>`}
        ${text && `<div class="promo-popup__content--text">${text}</div>`}
        ${button_text && `<a href="${button_url}" class="promo-popup__content--button button button--primary button--text button--full ">${button_text}</a>`}
      </div>
    `

    this.querySelector('.promo-popup__content')?.remove();
    this.querySelector('.promo-popup__wrapper').insertAdjacentHTML('beforeend', html);
    
    this.show();
  }
}

customElements.define('promo-popup', PromoPopup);
